import { ButtonMedium } from '@components/core-ui/form-elements/buttons/Button/variations/PrimaryButtonSizes';
import { getLoginButtonLabel } from '../helpers/getLoginButtonLabel';
import { TLoginStep } from '../types/TLoginStep';

type TProps = {
  disabled: boolean;
  isCheckingDomain: boolean;
  isRedirectingToSso: boolean;
  loginStep: TLoginStep;
};

export const LoginButton = ({ disabled, isCheckingDomain, isRedirectingToSso, loginStep }: TProps) => (
  <ButtonMedium
    aria-busy={isCheckingDomain || isRedirectingToSso}
    disabled={disabled}
    type="submit"
    className="mx-auto mb-[30px] w-full"
  >
    {getLoginButtonLabel(loginStep, isCheckingDomain, isRedirectingToSso)}
  </ButtonMedium>
);
